import { Card, Result } from "antd";

import "./style.css";
const AboutUs = () => {
  return (
    <div className="notfound-container">
      <Card className="aboutus-card">
        <Result
          status="404"
          title="404"
          subTitle="متاسفانه صفحه مورد نظر پیدا نشد."
          extra={<a href="/" type="primary">بازگشت به صفحه اصلی</a>}
        />
      </Card>
    </div>
  );
};

export default AboutUs;
